import type {GroupingMetadataWithSource} from '../../features/grouping/types'
import type {DropSide} from '../../helpers/dnd-kit/drop-helpers'
import type {MemexItemModel} from '../../models/memex-item-model'

export interface BaseDropEvent {
  activeItem: MemexItemModel
}

export interface DropOnRowEvent extends BaseDropEvent {
  overItem: MemexItemModel
  side: DropSide
  /** The parent of the target row, if dropping onto a sub-issue. Used to detect reparenting/adding parent. */
  overParentItem?: MemexItemModel
}

export interface DropSubIssueOnRowEvent extends DropOnRowEvent {
  /** The parent row of the sub-issue row that we are dropping. */
  parentItem: MemexItemModel
  /** The depth of the issue we are dropping within the sub-issue hierarchy. */
  subIssueDepth: number
}

export interface DropOnGroupEvent extends BaseDropEvent {
  activeItemGroup: GroupingMetadataWithSource
  overItemGroup: GroupingMetadataWithSource
}

export interface DropOnGroupedRowEvent extends DropOnGroupEvent, DropOnRowEvent {}

export type DropEvent = DropOnRowEvent | DropSubIssueOnRowEvent | DropOnGroupEvent | DropOnGroupedRowEvent

export const isDropOnGroup = (event: DropEvent | BaseDropEvent): event is DropOnGroupEvent =>
  'overItemGroup' in event && event.overItemGroup !== undefined

export const isDropOnRow = (event: DropEvent | BaseDropEvent): event is DropOnRowEvent =>
  'overItem' in event && event.overItem !== undefined

export const isDropSubIssueOnRow = (event: DropEvent | BaseDropEvent): event is DropSubIssueOnRowEvent =>
  isDropOnRow(event) && 'parentItem' in event && event.parentItem !== undefined
